import { displayNotification, displayToast, sendAppsignalError } from "../modules/utils";

class ShoppingCart {
  constructor(node) {
    this.element = node;
    this.dataShopType = this.element.dataset.shopType; // We only care if it's equal to "distributor"

    this.updateAllContentUrl = this.element.dataset.updateAllContentUrl;

    this.priceWrapper = this.element.querySelector(".js-shopping-cart-price-wrapper");
    this.checkoutButton = this.element.querySelector(".js-checkout-button");
    this.checkoutMobileButton = this.element.querySelector(".js-checkout-mobile-button");
    this.productsInCartElements = this.element.querySelectorAll("[data-js-class='add-to-cart']");
    this.productOutsideCartElements = this.element.querySelectorAll(".js-shopping-cart-add-to-cart");
    this.shoppingCartWrapper = this.element.querySelector(".js-shopping-cart-wrapper");
    this.contentWrappers = this.element.querySelectorAll(".js-content-wrapper");
    this.noticeWrapper = this.element.querySelector(".js-notice-wrapper");
    this.paymentMethods = this.element.querySelectorAll(".js-shopping-cart-payment-method");
    this.productCount = this.element.querySelector(".js-shopping-cart-product-count");

    this.returnToShopHMTL = this.element.querySelector(".js-return-to-shop").outerHTML;
    this.ajaxWrapperElements = this.element.querySelectorAll(".js-ajax-wrapper");
    this.ajaxTargetElements = this.element.querySelectorAll(".js-ajax-target");

    this.totalOrderValueElement = this.priceWrapper.querySelector(".js-total-order-value");
    this.discountElement = this.priceWrapper.querySelector(".js-discount");
    this.totalWithTaxElement = this.priceWrapper.querySelector(".js-total-with-tax");
    this.qvPointsElement = this.priceWrapper.querySelector(".js-qv-points");
    this.shippingCostElement = this.priceWrapper.querySelector(".js-shipping-cost");
    this.freeShippingWrapper = this.priceWrapper.querySelector(".js-free-shipping-wrapper");
    this.shippingNoticeElement = this.priceWrapper.querySelector(".js-shipping-notice");
    this.qvComponents = document.querySelectorAll("[data-js-class='qv']");

    this.ajaxWrappers = [];

    this.ajaxWrapperElements.forEach((ajaxWrapperElement, index) => {
      let object = {};

      object.element = ajaxWrapperElement;
      object.targetElement = this.ajaxTargetElements[index];

      this.ajaxWrappers.push(object);
    });

    this.initialize();
  }

  initialize() {
    this.observeCheckOutButton();

    this.addEventListenersToProductsInCart();
    this.addEventListenersToProductsOutsideCart();

    window.addEventListener("update-prices", () => {
      this.updatePrices();
    });
  }

  addEventListenersToProductsInCart(scope = this.productsInCartElements) {
    scope.forEach((productInCart) => {
      productInCart.addEventListener("quantity-changed", (e) => {
        const { detail } = e;

        this.fillShoppingCartDetails(detail);
        this.updateTotalProductCount();
      });

      productInCart.addEventListener("item-removed", (e) => {
        const { cart, recommendations } = e.detail;

        this.removeProductFromCart(productInCart);
        this.updateTotalProductCount();
        this.fillShoppingCartDetails(cart);

        this.updateRecommendations(recommendations);

        this.contentWrappers.forEach((contentWrapper) => {
          contentWrapper.classList.remove("is-loading");
        });
      });
    });
  }

  updateTotalProductCount() {
    const productsInCartInputs = this.shoppingCartWrapper.querySelectorAll(".js-quantity");
    let totalProductCount = 0;

    Array.from(productsInCartInputs).map((input) => {
      totalProductCount += parseInt(input.value);
    });

    this.productCount.innerHTML = totalProductCount;
  }

  addEventListenersToProductsOutsideCart() {
    this.productOutsideCartElements.forEach((productOutsideCart) => {
      productOutsideCart.addEventListener("click", () => {
        this.updateShoppingCart(productOutsideCart);
      });
    });
  }

  updateShoppingCart(product) {
    let url;
    if (product.dataset.cartDestroyUrl !== undefined) {
      url = product.dataset.cartDestroyUrl;
    } else {
      url = product.dataset.cartUrl;
    }

    this.contentWrappers.forEach((contentWrapper) => {
      contentWrapper.classList.add("is-loading");
    });

    const formData = new FormData();
    formData.append("quantity", 1);

    fetch(url, {
      retries: 3,
      retryDelay: 1000,
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: formData,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Error adding product to cart");
      })
      .then((data) => {
        const { addedProduct, cart, recommendations } = data;

        if (addedProduct !== "") {
          this.addNewProductToCart(addedProduct);
        }

        this.fillShoppingCartDetails(cart);
        this.updateRecommendations(recommendations);
        this.updateTotalProductCount();

        this.contentWrappers.forEach((contentWrapper) => {
          contentWrapper.classList.remove("is-loading");
        });
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorFetch);
        sendAppsignalError(e, "ShoppingCart", {
          response: this.response,
        });
      });
  }

  createElement(element) {
    const html = document.createElement("div");
    html.innerHTML = element;
    return html.firstChild;
  }

  handleProductsRecommendations(recommendations) {
    Object.keys(recommendations).forEach((key, index) => {
      const isProductNearCart = key === "productsNearCart";

      if (recommendations[key].length === 0) {
        this.ajaxWrappers[index].element.classList.add("d-none");

        if (isProductNearCart) {
          this.shoppingCartWrapper.insertAdjacentHTML("beforeEnd", this.returnToShopHMTL);
          this.tempReturnToShopHMTL = this.shoppingCartWrapper.querySelector(".js-return-to-shop");
        }
      } else {
        if (isProductNearCart) {
          if (this.tempReturnToShopHMTL) {
            this.tempReturnToShopHMTL.remove();
            this.tempReturnToShopHMTL = null;
          }

          // We double check here because if the page is loaded with a full shopping cart, the return to shop button is at a different position and we need to remove it (if there are suggestions near the cart.)
          let returnToShop = this.shoppingCartWrapper.querySelector(".js-return-to-shop");

          if (returnToShop) {
            returnToShop.remove();
          }
        }

        // TODO: might have to make this smarter since this requires the DOM to always draw these elements (incase the shopping cart is full of all products.)
        this.ajaxWrappers[index].element.classList.remove("d-none");

        recommendations[key].forEach((element) => {
          const htmlElement = this.createElement(element);
          this.ajaxWrappers[index].targetElement.appendChild(htmlElement);
        });
      }
    });
  }

  updateRecommendations(recommendations) {
    this.ajaxTargetElements.forEach((ajaxTargetElement) => {
      ajaxTargetElement.innerHTML = "";
    });

    this.handleProductsRecommendations(recommendations);

    this.productOutsideCartElements = this.element.querySelectorAll(".js-shopping-cart-add-to-cart");

    this.addEventListenersToProductsOutsideCart();
  }

  addNewProductToCart(shoppingCart) {
    const htmlElement = this.createElement(shoppingCart);
    this.shoppingCartWrapper.appendChild(htmlElement);

    htmlElement.scrollIntoView({ behavior: "smooth", block: "center" });
    window.Beyuna.initClasses(htmlElement);

    const addToCartElement = htmlElement.querySelectorAll("[data-js-class='add-to-cart']");

    this.addEventListenersToProductsInCart(addToCartElement);
  }

  observeCheckOutButton() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.checkoutMobileButton.classList.toggle("hidden", entry.isIntersecting);
      });
    });
    observer.observe(this.checkoutButton);
  }

  fillShoppingCartDetails(data, dispatchEvent = true) {
    const { totalAmountOfProducts, totalOrderValue, totalWithTax, discount, qvPoints, notices, disabledPaymentMethods, shippingCost, shippingCostElement, shippingNotice } = data;

    if (dispatchEvent) {
      this.qvComponents.forEach((qvComponent) => {
        qvComponent.dispatchEvent(new Event("qv-update"));
      });
    }

    window.dispatchEvent(new CustomEvent("cart-updated", { detail: totalAmountOfProducts }));

    this.noticeWrapper.innerHTML = "";
    this.totalOrderValueElement.innerHTML = totalOrderValue;
    this.totalWithTaxElement.innerHTML = totalWithTax;
    this.shippingCostElement.innerHTML = shippingCost === "" ? "-" : shippingCost;
    this.freeShippingWrapper.innerHTML = shippingCostElement;
    this.shippingNoticeElement.innerHTML = shippingNotice;

    if (this.dataShopType === "distributor") {
      this.discountElement.innerHTML = discount;
      this.qvPointsElement.innerHTML = qvPoints;
    }

    if (disabledPaymentMethods) {
      this.paymentMethods.forEach((paymentMethod) => {
        paymentMethod.classList.remove("disabled");
      });

      disabledPaymentMethods.forEach((paymentMethod) => {
        document.querySelector(`[data-payment-method="${paymentMethod}"]`).classList.add("disabled");
      });
    }

    if (notices) {
      // Notices may be given in string or array format. (empty strings are ignored)
      const noticesArray = Array.isArray(notices) ? notices : [notices];

      noticesArray.forEach((notice) => {
        if (notice.length === 0) return;

        displayNotification(notice, this.noticeWrapper, { type: "info", placement: "afterBegin" });
      });
    }
  }

  removeProductFromCart(item) {
    const productsInCart = this.shoppingCartWrapper.querySelectorAll(".product-shopping-cart");

    productsInCart.forEach((product) => {
      if (product.contains(item)) {
        if (productsInCart.length === 1) {
          window.location.reload(); // We reload the page to load the empty shopping cart view.
        }

        product.remove();
      }
    });
  }

  updatePrices() {
    this.shoppingCartWrapper.classList.add("is-loading");
    this.contentWrappers.forEach((contentWrapper) => {
      contentWrapper.classList.add("is-loading");
    });

    fetch(this.updateAllContentUrl, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Error updating prices");
      })
      .then((data) => {
        const { addedProducts, cart, recommendations } = data;

        this.updateAddedProducts(addedProducts);
        this.fillShoppingCartDetails(cart, false);
        this.updateRecommendations(recommendations);
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorFetch);
        sendAppsignalError(e, "ShoppingCart", {
          response: this.response,
        });
      })
      .finally(() => {
        this.shoppingCartWrapper.classList.remove("is-loading");
        this.contentWrappers.forEach((contentWrapper) => {
          contentWrapper.classList.remove("is-loading");
        });
      });
  }

  updateAddedProducts(addedProducts) {
    this.shoppingCartWrapper.innerHTML = "";
    addedProducts.forEach((product) => {
      this.shoppingCartWrapper.innerHTML += product;
    });

    this.productsInCartElements = this.element.querySelectorAll("[data-js-class='add-to-cart']");
    this.addEventListenersToProductsInCart();

    window.Beyuna.initClasses(this.shoppingCartWrapper);
  }
}

const shoppingCart = document.querySelector("[data-js='shopping-cart']");

if (shoppingCart) {
  new ShoppingCart(shoppingCart);
}
